// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"h2-z","sponsoredTooltipWrapper":"i2-z","sponsoredTooltip":"j2-z","newCard":"k2-z"};